module.exports = __webpack_public_path__ + "static/media/green@2x.83ac1075.png";